/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.0.0
 */

import { AccessComponentKeyEnum } from '../constants/guard/guardConstants';

/*
 * -------------------------------------------
 *            MENU CONDITION
 * -------------------------------------------
 */

export const MenuAccountKeys = [
    AccessComponentKeyEnum.FooterAccount,
    AccessComponentKeyEnum.PagePersonalAccount,
    AccessComponentKeyEnum.TabMenuAccount,
];

export const MenuServiceSubscriberKeys = [
    AccessComponentKeyEnum.FooterServicesSubscriberMobile,
    AccessComponentKeyEnum.PageSubscriberMobile,
    AccessComponentKeyEnum.TabMenuServicesSubscriber,
];

export const MenuHistoryOrderKeys = [
    AccessComponentKeyEnum.FooterHistoryOrder,
    AccessComponentKeyEnum.PageHistoryOrder,
    AccessComponentKeyEnum.TabMenuHistoryOrder,
];

export const MenuHistoryInquiryKeys = [
    AccessComponentKeyEnum.FooterHistoryInquiry,
    AccessComponentKeyEnum.PageHistoryInquiry,
    AccessComponentKeyEnum.TabMenuHistoryInquiry,
];

export const MenuOffersKeys = [
    AccessComponentKeyEnum.Campaigns,
    AccessComponentKeyEnum.FooterOffers,
    AccessComponentKeyEnum.PageOffers,
    AccessComponentKeyEnum.TabMenuOffers,
];

export const MenuMainKeys = [AccessComponentKeyEnum.TabMenuMain];

export const MenuCollectiveProductKeys = [AccessComponentKeyEnum.collectiveProduct];

/*
 * -------------------------------------------
 *            BUTTON CONDITION
 * -------------------------------------------
 */

export const FooterButtonKeys = [
    // ACCOUNT BUTTONS
    AccessComponentKeyEnum.FooterButtonBalanceUpdate,
    AccessComponentKeyEnum.FooterButtonBills,
    AccessComponentKeyEnum.FooterButtonDcruleList,
    AccessComponentKeyEnum.FooterButtonExpenses,
    AccessComponentKeyEnum.FooterButtonInquiryCreate,
    AccessComponentKeyEnum.FooterButtonInvoiceRepayment,
    AccessComponentKeyEnum.FooterButtonMoneyTransfer,
    AccessComponentKeyEnum.FooterButtonPayment,
    AccessComponentKeyEnum.FooterButtonReconciliation,
    AccessComponentKeyEnum.FooterButtonReports,
    // SUBSCRIBER MOBILE BUTTONS
    AccessComponentKeyEnum.FooterButtonLock,
    AccessComponentKeyEnum.FooterButtonDcruleChange,
    AccessComponentKeyEnum.FooterButtonRateServicesAndTariffOptions,
    AccessComponentKeyEnum.FooterButtonLabels,
    AccessComponentKeyEnum.FooterButtonAccessLevels,
    AccessComponentKeyEnum.FooterButtonTariffChange,
    AccessComponentKeyEnum.FooterButtonAdditionalAccount,
    AccessComponentKeyEnum.FooterButtonAdditionalReports,
    AccessComponentKeyEnum.FooterButtonCallDetails,
    // EXPENSES ANALYZER
    AccessComponentKeyEnum.FooterButtonWizardExpensesDetail,
];
